/**
 * Experiment that gates the Standards Alignment Report. Must exist and be
 * active in the Monolith segmentation service for the flag to do anything.
 */
export const STANDARDS_ALIGNMENT_REPORT_EXPERIMENT =
  "standards_alignment_report";

export const STANDARDS_ALIGNMENT_REPORT_HREF = "/state-standards/";
